import React, { Suspense } from 'react';
import { appInsightsHistory } from 'routing/appInsightsHistory';

// Redux
import { Provider } from 'react-redux';
import store from 'redux/store';

import AppRouter from 'routing/Router';

import { AppInsightsProvider, SentryContextProvider } from '@cc/common/sentry';
import { EnvironmentContext } from '@cc/common/contexts';
import { ErrorBoundary } from '@cc/common/components';

const AppFallback = () => (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div style={{ height: 90, backgroundColor: '#0072c6' }} />
        <div style={{ flex: 1, backgroundColor: '#f3f4f6' }} />
        <div style={{ height: 155, backgroundColor: '#555555' }} />
    </div>
);

function App() {
    return (
        <EnvironmentContext.Provider value={window.environment}>
            <Provider store={store}>
                <AppInsightsProvider history={appInsightsHistory}>
                    <SentryContextProvider>
                        <ErrorBoundary>
                            <Suspense fallback={<AppFallback />}>
                                <AppRouter />
                            </Suspense>
                        </ErrorBoundary>
                    </SentryContextProvider>
                </AppInsightsProvider>
            </Provider>
        </EnvironmentContext.Provider>
    );
}

export default App;
